export enum ActivationStatuses {
  ACTIVE_COMPLETED = 'ACTIVE_COMPLETED',
  PENDING_INPROGRESS = 'PENDING_INPROGRESS',
  NOT_ACTIVE = 'NOT_ACTIVE',
}

export enum CompanyTypes {
  ADVERTISER = 'ADVERTISER',
  PRODUCER = 'PRODUCER',
}

export enum UserTypes {
  BRAND = 'BRAND',
  AGENCY = 'AGENCY',
}

export enum NotificationTypes {
  SUCCESS = 'success',
  DANGER = 'danger',
}

export enum ModalSizes {
  LARGE = 'lg',
}

export enum ModalWindowClasses {
  ADD_NEW_COMPANY_USER = 'add-new-company-user-modal',
  COMPANY_ROLES_AND_PERMISSION = 'company-roles-and-permission-modal',
  ADMIN_USER_PROJECT_TEAMS = 'admin-user-project-teams-modal',
}

export enum ApiResponseMessages {
  OK = 'OK',
}

export enum SuccessMessages {
  DATA_SAVED = 'Data saved.',
}

export enum ButtonLabels {
  ACTIVATE = 'Activate',
  DEACTIVATE = 'Deactivate',
}

export enum ContentTypes {
  PROJECTS = 0,
  TEAMS = 1,
}

export enum StorageKeys {
  BRAND_ID = 'brandId',
}
